import { useQuery } from 'react-query';

import { QueryFunction, useRequest } from '@frontend/api';

import {
  ProductAvailabilityQueryKey,
  ProductAvailabilityRequestBody,
} from './types';
import { productAvailabilityQueryKey } from './utils';

export const useProductAvailability: QueryFunction<
  any,
  [ProductAvailabilityRequestBody],
  ProductAvailabilityQueryKey
> = (requestBody, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  const queryKey = productAvailabilityQueryKey(requestBody);

  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) => {
      return request('/products/product_availability', {
        init: {
          method: 'POST',
          body: requestBody,
          signal,
        },
      });
    },
  });
};
